export default "__VITE_ASSET__2Ki0PxAQ__"